import { parseQueryString } from '../utils/queryString';
import { useViewerRoute } from '../contexts/ViewerRoute';

import useHyperLinkClick from './mutation/link/useHyperLinkClick';

const useHandleHyperLinkClick = () => {
  const { historyId, isBulk } = useViewerRoute();

  const { mutate: mutateHyperLinkClick } = useHyperLinkClick();

  const handleUserHyperLinkClick = (hyperlinkId: number) => {
    mutateHyperLinkClick({
      hyperlinkId,
      historyId: parseQueryString(historyId),
      isBulk,
    });
  };

  return {
    handleUserHyperLinkClick,
  };
};

export default useHandleHyperLinkClick;
